module.exports = __webpack_public_path__ + "img/vk.318e606b.svg";